import { useCallback, useState } from "react";

const MSG = {
  unsupported: "Este navegador não oferece localização. Use o celular ou digite o endereço.",
  denied: "Permissão de localização negada — permita o acesso à localização nas configurações do navegador e tente de novo.",
  unavailable: "Não foi possível obter a localização agora (sem sinal de GPS). Tente perto de uma janela ou pelo celular.",
  timeout: "O GPS demorou demais para responder. Tente novamente.",
};

// Posição real do aparelho (GPS do navegador/celular). Retorna {lat, lng, precisao_m} ou lança Error com mensagem amigável.
export function getCurrentPosition(timeoutMs = 15000) {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) return reject(new Error(MSG.unsupported));
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, precisao_m: p.coords.accuracy }),
      (err) => reject(new Error(err.code === 1 ? MSG.denied : err.code === 2 ? MSG.unavailable : MSG.timeout)),
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 0 },
    );
  });
}

export function useGeolocation() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const locate = useCallback(async () => {
    setBusy(true); setError(null);
    try { return await getCurrentPosition(); }
    catch (e) { setError(e.message); throw e; }
    finally { setBusy(false); }
  }, []);
  return { locate, busy, error };
}

export const fmtPrecisao = (m) => (m == null ? null : m < 1000 ? `±${Math.round(m)} m` : `±${(m / 1000).toFixed(1)} km`);
